(() => {
  if (typeof subscribe !== 'function') return;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.html || !data.sectionId) return;
    const titleId = `OwlsTerpeneTitle-${data.sectionId}`;
    const copyId = `OwlsTerpeneCopy-${data.sectionId}`;
    for (const id of [titleId, copyId]) {
      const current = document.getElementById(id);
      const next = data.html.getElementById(id);
      if (!current || !next) continue;
      current.innerHTML = next.innerHTML;
      if (id === titleId) {
        current.dataset.owlsTerpeneMeta = next.dataset.owlsTerpeneMeta;
        const heading = current.querySelector('h1');
        if (heading) document.title = heading.textContent.trim();
        const description = document.querySelector('meta[name="description"]');
        if (description) description.content = next.dataset.owlsTerpeneMeta.trim();
        const ogTitle = document.querySelector('meta[property="og:title"]');
        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogTitle && heading) ogTitle.content = heading.textContent.trim().replace(/ \| Owls Oil$/, '');
        if (ogDescription) ogDescription.content = next.dataset.owlsTerpeneMeta.trim();
      }
    }
    const productSchema = (node) => {
      try {
        const value = JSON.parse(node.textContent);
        return value['@type'] === 'Product' ? value : null;
      } catch { return null; }
    };
    const nextSchema = Array.from(data.html.querySelectorAll('script[type="application/ld+json"]')).map(productSchema).find(Boolean);
    if (nextSchema) {
      const currentSchema = Array.from(document.querySelectorAll('script[type="application/ld+json"]')).find(node => productSchema(node));
      if (currentSchema) currentSchema.textContent = JSON.stringify(nextSchema);
    }
  });
})();
